import type { AuditRepository } from '@zetyar/data-contracts'
import { createSupabaseAuditRepository } from '@zetyar/supabase-client'
import { getSupabaseClient } from '@/infrastructure/supabase/app'

export const webAuditRepository: AuditRepository = createSupabaseAuditRepository(getSupabaseClient())
